"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const AppButton_vue_1 = require("@/client/components/common/AppButton.vue");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'SelectAmount',
    components: {
        AppButton: AppButton_vue_1.default,
    },
    props: {
        playerinput: {
            type: Object,
            required: true,
        },
        onsave: {
            type: Function,
            required: true,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data() {
        return {
            amount: this.playerinput.maxByDefault ? String(this.playerinput.max) : String(this.playerinput.min),
        };
    },
    methods: {
        saveData() {
            this.onsave({ type: 'amount', amount: parseInt(this.amount) });
        },
        setMaxValue() {
            this.amount = String(this.playerinput.max);
        },
    },
});
